import React from "react";
import {Payment} from "./pages/Payment";

export default function App() {
  return (
    <Payment />
  )
};